module.exports = __webpack_public_path__ + "img/faq.7bb05d78.png";